import { useState } from "react";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import ViewDeletePreCandidate from "./ViewDeletePreCandidate";
import { useTranslation } from "react-i18next";
import "./stylesDelete.scss";
import { usePrecandidateContext } from "../../../pages/precandidate/context//Context";

const ModalDeletePrecandidate = (props) => {
  const [confirmDelete, setConfirmDelete] = useState(false);
  const closeSetConfirmDelete = () => setConfirmDelete(false);
  const { t } = useTranslation();
  const { clearPrecandidateData } = usePrecandidateContext();

  const closeModalView = () => {
    props.setModalDeleteShow(false);
    clearPrecandidateData();
  };

  return (
    <ModalContainer
      modalTitle={t("View Pre-Candidate")}
      isOpen={props.modalDeleteShow}
      closeModal={() => props.setModalDeleteShow(false)}
      submitButtonAction={
        confirmDelete ? closeSetConfirmDelete : closeModalView
      }
      submitButtonTitle={t("Close")}
      modalSize="xl"
    >
      {!confirmDelete ? (
        <ViewDeletePreCandidate 
          precandidate={props.precandidate}
          setUpdatePreCandidateList={props.setUpdatePreCandidateList}
          updatePreCandidateList={props.updatePreCandidateList}
        />
      ) : (
        <div>
          <p>
            {t("Are you sure you want to delete ")}{" "}
            {props.precandidate.fullName}{" "}
            {t(" from the pre-candidate database?")}
          </p>
          <strong>{t("This action cannot be undone.")}</strong>
        </div>
      )}
    </ModalContainer>
  );
};

export default ModalDeletePrecandidate;